'use client';

import { useContext, useEffect } from 'react';

import { CartContext } from '@bytel/leviator/react';

import { getServerSession } from '@actions/get-session';

export function HandleCartLogin() {
    const { userConnect } = useContext(CartContext);

    useEffect(() => {
        getServerSession().then((session) => {
            if (session?.user) {
                userConnect(session.user).catch((error) => {
                    console.error('Error connecting user to cart:', error);
                });
            }
        });
    }, [userConnect]);

    return null;
}
